import React, { useEffect, useState } from "react";
import styles from "../../styles/components/emptwinOrderListing.module.scss";
import endpoints from "../../utility/endpoints";
import axios from "axios";
import router from "next/router";
export default function index(props) {
  const empid = JSON.parse(localStorage.getItem("empid"));
  const goTo = (link) => {
    router.push({
      pathname: link,
      query: { orderid: orderid },
    });
  };
  const [loader, setloader] = useState(false);
  const [orderdetails, setOrderdetails] = useState([]);
   const [globalSkillProcessName,setGlobalSkillProcessName]=useState([]);
  const [localSkillProcessName,setLocalSkillProcessName]=useState([]);
  const [softSkillProcessName,setSoftSkillProcessName]=useState([]);
  const [productSkillProcessName,setProductSkillProcessName]=useState([]);

  const orderDetails = async (e) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    setloader(true);
    const { data } = await axios({
      url: `${endpoints.baseUrl}/twin/employee_order?businessRequest=${auth.email}`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
    });
    //console.log(data);
    if (data.code === 200) {
      setloader(false);
      setOrderdetails(data.data);
//            setGlobalSkillProcessName(data.globalSkillProcessName);
  //    setLocalSkillProcessName(data.localSkillProcessName);
    //  setSoftSkillProcessName(data.softSkillProcessName)
     // setProductSkillProcessName(data.prdouctTitle)
    } else {
      console.log("No data found");
      setloader(false);
    }
  };
  //console.log("orderdetails", orderdetails);
 
  React.useEffect(() => {
    orderDetails();
  }, []);
  //console.log(props, "Emptwin banner data");
  let numItems = orderdetails.map((item, index) => {
    if (item) {
      return item.employeeTwinID;
    }
  });
  numItems = numItems.filter((item) => item !== undefined);
  //console.log("numItems", numItems.length);
  return (
    <>
      <div className={`${styles.emptwinorderlisting} container`}>
        {loader ? (
          <div
            className={`${styles.container} ${styles.containerHeight}`}
          >
            <div className={`${styles.loader} ${styles.loader3}`}></div>
          </div>
        ) : (
          <div className={`${styles.row} row pb-4`}>
            <div className="col-lg-12 col-md-12 col-12 pt-4">
              <table className={styles.tableskill} >
                {numItems.length > 0 ? (
                  <>
                    <tr className={`${styles.bottext1}`}>
                      <td>
                        <h2 className={styles.heading}>Order Details</h2>
                      </td>
                      <td>
                        <h2 className={styles.heading}>
                          {orderDetails.length > 0
                            ? `${numItems.length} ${
                                orderdetails.length <= 1 ? "Item" : "Items"
                              }`
                            : ""}
                        </h2>
                      </td>
                    </tr>
                    <tr className={styles.bottext2}></tr>
                  </>
                ) : (
                  ""
                )}

                
                      <tr  className={styles.skilllist} style={{background: "#1f36c7",color:"#fff"}}>
                      
                      <td className={styles.skillheading}>Order Id</td>
                      <td className={styles.skillheading}>Name</td>
                      <td className={styles.skillheading} style={{width:"15%"}}>Profile</td>
                      <td className={styles.skillheading}>Soft Skills</td>
                      <td className={styles.skillheading}>Global Skills</td>

 <td className={styles.skillheading}>ETA (Global & Soft Skill)</td>
                      <td className={styles.skillheading}>Local Skills</td>
                      <td className={styles.skillheading}>Delivery Date</td>
                      </tr>
    {orderdetails.map((item, index) => {
                  
                  
                    const {
                      orderID,
                      softSkill,
                      globalSkill,
                      localSkill,
                      goLiveDate,
                      product_id,
                      createdAt,
                      updatedAt,
                      ETname,
                      Etprofile,
                      GlobalSkill_ProcessName,
                      localSkill_ProcessName,
                      softSkill_ProcessName,
                      productSkill_ProcessName
                    } = item;


                                 // let GlobalSkill_ProcessName1=[GlobalSkill_ProcessName];
                  
                 //   let localSkill_ProcessName1=[localSkill_ProcessName];
                    
                   // let softSkill_ProcessName1=[softSkill_ProcessName];
                    //softSkill_ProcessName1=softSkill_ProcessName;
                   // let productSkill_ProcessName1=[productSkill_ProcessName];

 let a=GlobalSkill_ProcessName.split(",")
                    let GlobalSkill_ProcessName1=a;
                    let b=localSkill_ProcessName.split(",")
                    let localSkill_ProcessName1=b;
                    let c=softSkill_ProcessName.split(",")
                    let softSkill_ProcessName1=c;
                    let d=productSkill_ProcessName.split(",")
                    let productSkill_ProcessName1=d;
 const date1 = new Date();
                  const date2 = new Date(updatedAt);
                  const diffTime = date2.getTime() - date1.getTime();
                  let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                 const date = new Date(updatedAt).toLocaleDateString();      
                    return (
                      <>
                      <tr  className={styles.skilllist}>
                      
                          <td><span className={`${styles.rightText}`}>
                              {orderID}
                            </span></td>
                          <td><span className={`${styles.rightText}`}>
                              {ETname}
                            </span></td>
                            <td>{Etprofile?
                              <img src={Etprofile} style={{maxWidth:"50%",verticalAlign: "middle"}}/>:null}
                            </td>
                         
                          <td> {softSkill_ProcessName1.map((item,index)=>
                              {
                                
                                return(<><span key={index}>{item}</span><br/></>)
                              })}</td>
                          <td> {GlobalSkill_ProcessName1.map((item,index)=>
                              {
                                
                                return(<><span key={index}>{item}</span><br/></>)
                              })}
                              {productSkill_ProcessName1.map((item,index)=>
                              {
                                
                                return(<><span key={index}>{item}</span><br/></>)
                              })}</td>
 <td> <span className={`${styles.rightText}`}>
                             {date}
                            </span></td>

                          <td> {localSkill_ProcessName1.map((item,index)=>
                              {
                                                                return(<><span key={index}>{item}</span><br/></>)
                              })}</td>
                          
                         <td> {/*<span className={`${styles.rightText}`}>
                              {goLiveDate}Team will reach out to you.</span>*/}
                          { localSkill_ProcessName1[0].length <=0?null:<span className={`${styles.rightText}`}>Team will reach out to you.</span>}                         
</td>
                                                
                      </tr>
                      </>
                    );
                  
                })}
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

